const tendenciasRoutes = [
  {
    path: "/tendencias",
    name: "tendencias.index",
    component: () => import("@/modules/tendencias/views/TrendsIndex.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Tendências",
    },
  },
  {
    path: "/tendencias/mercado-livre",
    name: "tendencias.mercadolivre",
    component: () => import("@/modules/tendencias/views/MercadoLivreTrends.vue"),
    meta: {
      env: ["production"],
      roles: [1, 2, 5, 6],
      pageTitle: "Tendências - Mercado Livre",
    },
  },
];

export default tendenciasRoutes;
